import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <rect
      width={1.155}
      height={8.084}
      x={8.458}
      y={2.725}
      fill="#fff"
      rx={0.577}
      transform="rotate(45 8.458 2.725)"
    />
    <rect
      width={1.155}
      height={8.084}
      x={9.267}
      y={8.455}
      fill="#fff"
      rx={0.577}
      transform="rotate(135 9.267 8.455)"
    />
  </svg>
)
export default SvgComponent
